<template>
  <ValidationObserver ref="observer" v-slot="{ invalid }">
    <tsny-modal
      :modal-id="modalId"
      :modal-title="'Create Session Report'"
      :submit-button-text="'SUBMIT'"
      :submit-disabled="invalid"
      :reset-modal="resetModal"
      :submit-modal="createSessionReport"
    >
      <b-form>
        <b-row>
          <b-col>
            <b-text-input-validated
              type="date"
              v-model="date"
              rules="required"
              name="date"
              label="Session Date"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-text-input-validated
              type="time"
              v-model="startTime"
              rules="required"
              name="start"
              label="Session Start"
          /></b-col>
          <b-col
            ><b-text-input-validated
              type="time"
              v-model="endTime"
              rules="required"
              name="end"
              label="Session End"
          /></b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-text-input-validated
              text-area
              v-model="report"
              rules="required"
              name="report"
              label="Report"
              placeholder="Describe what was covered in the session. This is public and will be seen by your student"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-text-input-validated
              text-area
              v-model="assignment"
              rules="required"
              name="assignment"
              label="Assignment"
              placeholder="What does your student need to do before your next session?"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-text-input-validated
              text-area
              v-model="notes"
              label="Notes"
              placeholder="(optional) Any other notes you have on the session or the student that might be useful, particularly if another tutor has to cover a session for you. This is private and will not be seen by the student"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p v-if="createSessionReportError" class="tsny_status-text">
              An error occurred creating the session report
            </p>
          </b-col>
        </b-row>
      </b-form>
    </tsny-modal>
  </ValidationObserver>
</template>

<script>
import TsnyModal from "../TsnyModal";
import StoreConstants from "../../store/services/StoreConstants";
import { mapGetters } from "vuex";
import CourseRelationshipRestService from "../../services/rest/services/CourseRelationshipRestService";
import EventBus from "../../services/eventBus/EventBus";
import EventConstants from "../../services/eventBus/EventConstants";
import { ValidationObserver } from "vee-validate";
import BTextInputValidated from "../FormInputs/BTextInputValidated";
export default {
  name: "CreateSessionReportModal",
  components: { TsnyModal, ValidationObserver, BTextInputValidated },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      courseGetter: StoreConstants.GETTERS.COURSE
    }),
    course: function() {
      return this.courseGetter(this.id);
    },
    storeDate: function() {
      return this.course.nextSessionDate;
    },
    storeStartTime: function() {
      return this.course.nextSessionStartTime;
    },
    storeEndTime: function() {
      return this.course.nextSessionEndTime;
    }
  },
  data: function() {
    return {
      modalId: "createSessionReportModal",
      date: null,
      startTime: null,
      endTime: null,
      report: null,
      assignment: null,
      notes: null,
      createSessionReportError: null
    };
  },
  methods: {
    createSessionReport: async function(bvModalEvent) {
      bvModalEvent.preventDefault();

      let $comp = this,
        isValid = await this.$refs.observer.validate();

      if (!isValid) return;

      $comp.createSessionReportError = false;

      return CourseRelationshipRestService.createSessionReport(
        $comp.course._id,
        {
          date: $comp.date,
          startTime: $comp.startTime,
          endTime: $comp.endTime,
          report: $comp.report,
          assignment: $comp.assignment,
          notes: $comp.notes
        }
      )
        .then(() => {
          $comp.$bvModal.hide($comp.modalId);
          EventBus.$emit(EventConstants.EVENTS.SESSION_REPORT_CREATED);
        })
        .catch(err => {
          console.log(err);
          $comp.createSessionReportError = true;
        });
    },
    resetModal: function() {
      this.date = this.storeDate;
      this.startTime = this.storeStartTime;
      this.endTime = this.storeEndTime;
      this.report = null;
      this.assignment = null;
      this.notes = null;
      this.createSessionReportError = null;
    }
  }
};
</script>

<style scoped></style>
